import React from 'react';

import { CmsQuestRequirement } from 'components/quests/cms-hooks/types';
import { IQuest } from 'components/quests/loyalty-quest/types';
import { Tier } from 'components/quests/loyalty-quest/utils';
import { ILoyaltyQuestsUiDetailFragment } from 'generated/sanity-graphql';

import { TierCard } from '../tier-card';

interface IRegularStepsProps {
  quest: IQuest;
  // For regular quests `getQuestTiers` returns a single tier whose
  // `bonusPoints` already falls back to `quest.bonusPoints`.
  tier: Tier;
  // @TODO: Add proper type for cmsSteps
  cmsSteps: any;
  cmsQuestRequirementById: CmsQuestRequirement;
  cmsQuestDetailUI: ILoyaltyQuestsUiDetailFragment;
  onCloseDrawer: () => void;
}

export const RegularSteps = ({
  quest,
  tier,
  cmsSteps,
  cmsQuestRequirementById,
  cmsQuestDetailUI,
  onCloseDrawer,
}: IRegularStepsProps) => {
  return (
    <TierCard
      tier={tier}
      quest={quest}
      cmsSteps={cmsSteps}
      cmsQuestRequirementById={cmsQuestRequirementById}
      cmsQuestDetailUI={cmsQuestDetailUI}
      onCloseDrawer={onCloseDrawer}
      isFirstTier
    />
  );
};
